/* constant/index.js */

// 依據建置環境選擇對應變數定義檔 (webpack.DefinePlugin)
const envConstant = require('./' + process.env.NODE_ENV + '.js').default
export default envConstant


// WEBPACK FOOTER //
// ./src/constant/index.js